var firebase = require("firebase");
const config = {
  apiKey: "AIzaSyATmdx489awEXPhT8dhTv4eQzX3JW308vc",
  authDomain: "eviusauth.firebaseapp.com",
  databaseURL: "https://eviusauth.firebaseio.com",
  projectId: "eviusauth",
  storageBucket: "",
  messagingSenderId: "400499146867",
};
firebase.initializeApp(config);
export default firebase;
